export { revalidateCommunity } from 'next-flight-server-reference-proxy-loader?id=40f3ddc625f03b61d59d5544e7d8081d8ebbc88bbd&name=revalidateCommunity!'